import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Stack, Typography, TextField } from "@mui/material";

export default function Main() {
  const init_form = { apexdomain: "" };
  const [form, set_form] = useState(init_form);

  const navigate = useNavigate();

  function update_form(e) {
    const { name, value } = e.target;
    set_form((prev_form) => ({ ...prev_form, [name]: value }));
  }
  function on_key_press(e) {
    if (e.key === "Enter") {
      const apexdomain = form.apexdomain.trim();
      if (apexdomain) navigate(`/scan/${apexdomain}`);
    }
  }

  return (
    <Stack sx={sx.wrapper}>
      <Stack sx={sx.container}>
        <Typography sx={sx.title}>What do you want to protect?</Typography>
        {/* <Typography sx={sx.subtitle}>Some sort of subtitle</Typography> */}

        <TextField
          name="apexdomain"
          value={form.apexdomain}
          onChange={update_form}
          onKeyPress={on_key_press}
          sx={sx.searchbar}
        />

        <Typography sx={sx.upload_btn}>Upload Targets [DEV]</Typography>
      </Stack>
    </Stack>
  );
}

const sx = {
  wrapper: {
    width: 1,
    height: "100vh",
    alignItems: "center",
  },
  container: {
    p: 2,
    mt: 30,
    alignItems: "center",
  },
  title: {
    fontSize: 40,
    mb: 1,
  },
  subtitle: {
    fontSize: 20,
    color: "gray",
    mb: 3,
  },
  searchbar: {
    width: 700,
    mb: 1,
  },
  upload_btn: {
    p: 1,
    borderRadius: "10px",
    cursor: "pointer",
    "&:hover": { backgroundColor: "lightgrey" },
  },
};
